<template>
  <div>
    <Layout/>
    <h4>Citas Pendientes</h4>
    <hr>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">FechaReg</th>
          <th scope="col">FechaAct</th>
          <th scope="col">FechaCita</th>
          <th scope="col">Hora Desde</th>
          <th scope="col">Hora Hasta</th>
          <th scope="col">EstadoCita</th>
          <th scope="col">Descripción</th>
          <th scope="col">Observación</th>
          <th scope="col">EmpresaNombre</th>
          <th scope="col">PersonaFechaReg</th>
        </tr>
      </thead>
    <tbody>
      <tr v-for="cita in datosPaginados" :key="cita.idCita">
        <td><a href="http://localhost:8080/api/v1/reportes/pdf/1/2"><i class="material-icons" style="font-size:24px;color:red; cursor: pointer;">picture_as_pdf</i></a></td>
          <td>{{getFormattedDate(cita.fechaReg)}}</td>
          <td>{{getFormattedDate(cita.fechaAct)}}</td>
          <td>{{getFormattedDate(cita.fechaCita)}}</td>
          <td>{{cita.horaDesde}}</td>
          <td>{{cita.horaHasta}}</td>
          <td>{{cita.estadoCita}}</td>
          <td>{{cita.descripcion}}</td>
          <td>{{cita.observacion}}</td>
          <td>{{cita.empresaNombre}}</td>
          <td>{{getFormattedDate(cita.personaFechaReg)}}</td>
        <td><button class="btn btn-light" @click="aprobarEstadoCita(cita)">Aprobar</button></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import dateFormat from '@/modules/dateFormat.js';
import api from "@/services/api";
import * as $ from 'jquery';
import swal from  'sweetalert'
window["$"] = $;
window["jQuery"] = $;
export default {
  inject:['reload'],
  components : {
    Layout, Footer
  },
  data () {
    return {
      citas : [],
      titulo:'',
      btnCrear:false,
      btnEditar:false,
      idPza:'',
      elementosPorPagina:10,
      datosPaginados:[],
      paginaActual:1
    }
  },
  mounted () {
    this.getDataPagina(this.paginaActual)
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas(){
      return Math.ceil(this.citas.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      api.get('/vwcitas/estadocita/PENDIENTE').then(response=>{
      this.citas=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.citas.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    changeColor() {
        $('body').removeClass()
        $('body').addClass(this.className)
    },
    reload(){
      this.isRouterAlive = false
      this.$nextTick(function(){
        this.isRouterAlive = true
      })
    },
    async aprobarEstadoCita(p_Cita){
      p_Cita.estadoCita = 'APROBADA';
      try {
          await api.post('/citas/actestadocita', p_Cita)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Orden creado(a) exitosamente!", "success");
       } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
    }
  }
}
</script>
